




import Vue from 'vue';
import ContentAdd from '@/components/content/content-add.component.vue';

export default Vue.extend({
  components: {
    'content-add': ContentAdd,
  },
});
